// visualizer.js
var Visualizer = pc.createScript('visualizer');


// Visualizer.attributes.add('analyser', {
//     type: 'entity'
// });
Visualizer.attributes.add('freqcolor', {
    type: 'rgba'
});

Visualizer.attributes.add('timecolor', {
    type: 'rgba'
});

Visualizer.attributes.add('heightScale', {
    type: 'number',
    default: 1
});

// initialize code called once per entity
Visualizer.prototype.initialize = function() {
    this.analyser = this.app.root.findByName('syncLoop');
   // console.log(this.analyser);
    this.lines = [];
    var count = this.analyser.script.analyser.fftsize;
    for (var i = 0; i < count; i++) {
        this.lines.push(new pc.Vec3());
    }

    this.yScale = 1;
    this.xScale = 0.10 * 2048 / count;
   // console.info(this.analyser);
    this.minDb = this.analyser.script.analyser.analyser.minDecibels;
    this.maxDb = this.analyser.script.analyser.analyser.maxDecibels;
    this.freqScale = 1 / (this.maxDb - this.minDb);
    this.freqOffset = this.minDb;

};

// update code called every frame
Visualizer.prototype.update = function(dt) {
    this.freqScale = 1 / (this.maxDb - this.minDb);
    this.freqOffset = this.minDb;
   // console.log(this.analyser.script.analyser.freqData[0]);
    //console.info(this.analyser.script.analyser.freqData[1] / -100);
    var scl = this.analyser.script.analyser.freqData[0] / 100;
    var iScl = this.entity.getLocalScale().x;
    var uniform = iScl + scl;
    this.entity.setLocalScale(uniform,uniform,uniform);
    
    //this.fadeElements[0].render.material.emissiveIntensity = this.analyser.script.analyser.freqData[64] / -100;
    //console.info(this.analyser.script.analyser.freqData);
    //this.fadeElements[0].render.material.update();



    // this.renderData(this.analyser.script.analyser.freqData, this.freqcolor, this.freqScale, this.freqOffset);
    // this.renderData(this.analyser.script.analyser.timeData, this.timecolor, 0.5, 0);
};


Visualizer.prototype.renderData = function (data, color, scale, offset) {
    // var line = 0;
    // for (var i = 0; i < data.length; i++) {
    //     if (line < this.lines.length) {
    //         var h1 = scale * (data[i] - offset);
    //         var h2 = scale * (data[i+1] - offset);

    //         this.lines[line].set(i * this.xScale, this.heightScale*h1, 0);
    //         this.lines[line+1].set((i+1) * this.xScale, this.heightScale*h2, 0);

    //         line += 2;
    //     }
    // }
    // this.app.renderLines(this.lines, color);
};

